import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { debounceTime } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';

import { InlineEditComponent } from '../../../../shared/components/inline-edit/inline-edit.component';
import { InvitationOptionsComponent } from 'src/app/shared/components/invitation-options-component/invitation-options.component';
import { SupplierService } from '../../services/supplier.service';
import { Invitation } from '../../../../shared/components/invitation-options-component/invitation';

@Component({
  selector: 'app-supplier-invitations',
  templateUrl: './supplier-invitations.component.html',
  styleUrls: ['./supplier-invitations.component.scss']
})
export class SupplierInvitationsComponent implements OnInit {
  public settings = {
    actions: 'false',
    hideSubHeader: true,
    columns: {
      email: {
        title: 'Email',
        type: 'custom',
        renderComponent: InlineEditComponent,
        onComponentInitFunction: (instance: InlineEditComponent) => {
          instance.valueEmitter
            .pipe(debounceTime(200))
            .subscribe(value => {
              const invitation = this.invitations.find(e => e.isDraft === true);

              if (invitation) {
                invitation.email = value;
              }
            });
        },
        valuePrepareFunction: (rowData: any, cell: any, value: any) => {
          return {
            type: 'email',
            data: rowData,
            cell
          };
        }
      },
      lastName: {
        title: 'Nume'
      },
      firstName: {
        title: 'Prenume'
      },
      cnp: {
        title: 'CNP'
      },
      status: {
        title: 'Status'
      },
      optiuni: {
        title: 'Optiuni',
        type: 'custom',
        renderComponent: InvitationOptionsComponent,
        valuePrepareFunction: (rowData: any, cell: any, value: any) => {
          return {
            data: rowData,
            cell
          };
        },
        onComponentInitFunction: (instance: InvitationOptionsComponent) => {
          instance.inactivate.subscribe((row: Invitation) => {
            this.supplierService.removeInvitation(row.id)
              .subscribe(value => {
                this.updateInvitation(value);
              });
          });
          instance.delete.subscribe((row: Invitation) => {
            if (!!row.isDraft) {
              this.removeInvitation(row);
            } else {
              this.supplierService.removeInvitation(row.id)
                .subscribe(() => {
                  this.removeInvitation(row);
                });
            }
          });
          instance.sendInvite.subscribe((row: Invitation) => {
            this.supplierService.addInvitation(row).subscribe(e => {
              this.isAddingInvitation = false;
              this.updateInvitation(e);
            });
          });
        },
      },
    }
  };

  public isAddingInvitation = false;
  public invitations = [];

  constructor(
    private supplierService: SupplierService,
    private changeDetectorRef: ChangeDetectorRef,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.supplierService.getInvitations()
      .subscribe((invitations) => this.invitations = invitations);
  }

  removeInvitation(invitation: Invitation): void {
    const exists = this.invitations.some(e => e.id === invitation.id);
    if (exists) {
      this.invitations = this.invitations.filter(e => e.id !== invitation.id);
    } else {
      this.invitations = this.invitations.filter(e => e.isDraft !== true);
    }
  }

  updateInvitation(invitation: Invitation): void {
    const exists = this.invitations.some(e => e.id === invitation.id);
    if (exists) {
      this.invitations = this.invitations.map(e => e.id !== invitation.id ? e : invitation);
    } else {
      this.invitations = this.invitations.map(e => e.isDraft === true ? invitation : e);
    }
  }

  addInvitation(): void {
    const invitationList = [];
    const newEntry: Invitation = {
      isDraft: true,
      email: ''
    };
    this.invitations.unshift(newEntry);
    invitationList.push(...this.invitations);
    this.invitations = invitationList;

    this.isAddingInvitation = true;
    this.changeDetectorRef.detectChanges();
  }

  /*onCompanySelect(event: any) {
    const selectedCompany = event.target.value;
    this.companyDetailsService.getUserOwnedCompanyLegalRepresentatives(selectedCompany).subscribe(
      e => {
        this.selectedCompany = selectedCompany;
        this.legalRepresentatives = e;
        this.isAddingLegalRepresentative = false;

        console.log(e);
      }
    );
  }*/

}
